// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1uXBe","content":"RecentSearches_content__1hKrw"};